import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
	selector: 'vex-landing',
	templateUrl: './landing.component.html',
	styleUrls: ['./landing.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
})
export class LandingComponent {}
